import { useEffect, useState } from 'react';

export const MOBILE_VIEWPORT_WIDTH = 640;

export function useIsMobileViewport(breakpoint: number = MOBILE_VIEWPORT_WIDTH): boolean {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && window.innerWidth <= breakpoint,
  );

  useEffect(() => {
    const measure = () => setIsMobile(window.innerWidth <= breakpoint);
    measure();

    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, [breakpoint]);

  return isMobile;
}
